import React from 'react';

import { ICampaignProps } from '@domain/interfaces/dashboard/AdsManager/Table/Campaign/ICampaign';
import { IBoleto } from '@domain/interfaces/dashboard/AdsManager/AdSenseCampaigns/IAdSenseCampaign';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { numberFormatter } from '@helpers/masks';

import BlurredContent from './BlurredContent';

import * as S from './styles';

const Boleto: React.FC<ICampaignProps> = ({ data, rowData }) => {
  const boletoData: IBoleto = data;

  const { store } = useStoreConfig();
  const { isDemoEnvironment } = useConfig();

  const isContentBlurred =
    (!store.is_utm_onboarding_finished || !rowData.has_at_least_one_ads_with_utm_synchronized) &&
    !isDemoEnvironment &&
    !rowData.has_all_ads_with_utm_synchronized;

  return (
    <S.Wrapper>
      {isContentBlurred ? (
        <BlurredContent />
      ) : (
        <>
          <S.ContentWrapper>
            <S.LabelText>Receita</S.LabelText>
            <S.AmountText>{`R$ ${numberFormatter(boletoData.amount, 2)}`}</S.AmountText>
          </S.ContentWrapper>

          <S.ContentWrapper>
            <S.LabelText>CPA</S.LabelText>
            <S.AmountText>{`R$ ${numberFormatter(boletoData.cpa_amount, 2)}`}</S.AmountText>
          </S.ContentWrapper>
        </>
      )}
    </S.Wrapper>
  );
};

export default Boleto;
